import React from 'react';
import {_NumberWithSpaces} from 'constants/index';
import logo from 'assets/images/logo.png';
import {IVoucherDetails} from 'constants/interfaces';

type InvoiceProp = {
  data: any;
};
export default class Invoice extends React.Component<InvoiceProp> {
  state: {
    companyAddress: Array<string>;
    total: number;
    src: string;
  } = {
    companyAddress: [
      '32 Roos Street',
      'Fourways Golf Park',
      'Johannesburg',
      '2191',
    ],
    total: 0,
    src: '',
  };

  render() {
    const {companyAddress} = this.state;
    const {data} = this.props;
    return (
      <div className="panel-content-container invoice invoice-container column panel-child">
        <div className="row khula-info">
          <div>
            <img className="company-logo" src={logo} alt="" />
          </div>
          <div className="address">
            {companyAddress.map((line, index: number) => (
              <div key={index} className="line">
                {line}
              </div>
            ))}
          </div>
        </div>
        <div className="row client-info">
          <div className="address">
            {companyAddress.map((line, index: number) => (
              <div key={index} className="line">
                {line}
              </div>
            ))}
          </div>
          <div className="invoice-details font-weight-400">
            <div>INV: #KHULA-{data.id}</div>
            <div>{new Date(parseFloat(data.insertedOn)).toDateString()}</div>
            <div className="icon">
              <span className="ic icon-envelope"></span>
              <span className="ic icon-download"></span>
            </div>
          </div>
        </div>
        <div className="product-table">
          {data.vouchers.map((voucher: IVoucherDetails, index: number) => (
            <div key={index}>
              {index + 1}.{' '}
              {voucher.categories ? voucher.categories.toString() : ''}
            </div>
          ))}
          <div className="row total">
            <div>Total</div>
            <div className="green">
              R {_NumberWithSpaces(data.assignedAmount)}
            </div>
          </div>
        </div>
        <div className="payment-details address">
          <div className="bold">Pay via EFT to:</div>
          <div>
            Bank: <span className="bold">FNB</span>
          </div>
          <div>
            Account Number:<span className="bold"> 62562362769</span>
          </div>
          <div>
            Reference: <span className="bold">#KHULA-{data.id}</span>
          </div>
        </div>
      </div>
    );
  }
}
